









































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { Conto } from '@/data/models/conto.model';
import { Movement } from '@/data/models/movimento.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { CrudService } from '@/data/services/crud.service';

@Component
export default class CassaList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	
	@Inject('CrudService') crudService!: CrudService<Movement>;

	rows: Movement[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('movement');

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadCassa() {
		const datareq = this.crudService.searchEntities(
			Movement,
			'movement',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Movement,
			'movement',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	editConto(item: Conto) {
		this.$emit('edit', item);
	}

	deleteConto(item: Conto) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadCassa();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadCassa();
	}

}
